const Key_User_ID = 'key-user-id' 
const Key_User_Name = 'key-user-name'
export function getUserId() {
   return localStorage.getItem(Key_User_ID)
}

export function setUserId(userId) {
  return localStorage.setItem(Key_User_ID,userId)
}

export function getUserName() {
  return localStorage.getItem(Key_User_Name)
}

export function setUserName(userName) {
  return localStorage.setItem(Key_User_Name,userName)
}

export function RemoveUserId() {
  return localStorage.removeItem(Key_User_ID)
}

export function RemoveUserName() {
  return localStorage.removeItem(Key_User_Name)
}
